<template>
  <div class="layout column ma-0 tournament">
    <div class="container">
      <transition-group
        tag="div"
        name="fade-transition"
        appear
        class="layout column"
      >
        <div key="text" class="page-section tournament__text">
          <div class="page-section__content">
            <div class="text-xs-center heading">
              Red Bull Tournament
            </div>
            <div class="text-xs-center subheading">
              {{ tournament.name }}
            </div>
          </div>
        </div>

        <div
          key="format"
          class="page-section tournament__format"
          v-if="tournament.id"
        >
          <div class="page-section__content page-section_card">
            <div class="tournament__format_wrap layout">
              <div class="flex field field_countdown">
                <div class="label" v-if="tournamentStatuses.NotStarted">
                  До турнира осталось:
                </div>
                <div class="label" v-else>
                  Статус турнира:
                </div>
                <Countdown :endtime="tournament.starts_at">
                  <div
                    v-if="tournamentStatuses.Live"
                    class="tournament__status live"
                  >
                    <app-status>LIVE</app-status>
                  </div>
                  <div
                    v-if="tournamentStatuses.Over"
                    class="tournament__status ended"
                  >
                    Окончен
                  </div>
                </Countdown>
              </div>
              <div class="flex field field_date">
                <div class="label">Дата начала регистрации:</div>
                <div class="info">
                  {{
                    tournament.registration_starts_at
                      | dayjs("DD.MM.YYYY HH:mm")
                  }}
                </div>
              </div>
              <div class="flex field field_date">
                <div class="label">Дата старта игр:</div>
                <div class="info">
                  {{ tournament.starts_at | dayjs("DD.MM.YYYY HH:mm") }}
                </div>
              </div>
              <div class="flex field field_count">
                <div class="label">Мест:</div>
                <div class="info" v-if="tournament.type == 1">
                  {{ tournament.players_count || 0 }} /
                  {{ tournament.players_limit || 0 }}
                </div>
                <div class="info" v-else>
                  {{ tournament.players_limit || 0 }}
                </div>
              </div>

              <div class="flex field field_btn" v-if="canRegister">
                <app-btn
                  v-if="needShowParticipateBtn"
                  color="yellow-grad"
                  border="bottom"
                  :loading="participateLoading"
                  @click="participateTournament()"
                >
                  Принять участие
                </app-btn>

                <app-btn
                  v-else-if="needShowCheckinBtn"
                  color="yellow-grad"
                  border="bottom"
                  @click="confirmTournamentRegistration()"
                >
                  Подтвердить участие
                </app-btn>

                <div v-else class="info registred registred_success">
                  <div class="registred__icon">
                    <SvgIcon size="20" name="check" />
                  </div>
                  <div v-if="isCheckinConfirmed" class="registred__text">
                    Вы участвуете в <b>квалификации</b>
                  </div>
                  <div v-else class="registred__text">
                    Вы зарегистрированы на <b>квалификацию</b>
                  </div>
                </div>
              </div>

              <div
                class="flex field field_address"
                v-if="tournament.address && tournament.address.length"
              >
                <div class="label">Адрес:</div>
                <div class="info">
                  {{ tournament.address }}
                </div>
              </div>

              <div class="flex field field_format">
                <div class="label">Формат:</div>
                <div class="info">
                  <span class="ellipsis">
                    {{ tournament.format }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          key="notice"
          class="page-section tournament__notice"
          v-if="tournament.id && isParticipant"
        >
          <div class="page-section__content page-section_card">
            <p class="title">Уважаемые участники соревнования!</p>
            <p>
              Мы&nbsp;просим вас присоединиться к&nbsp;дискорд каналу
              <app-btn
                link
                :to="getLink('tournament-info', { hash: '#discord' })"
                ><img
                  height="14"
                  src="@/assets/img/discord-text-color.svg"
                  alt="Discord"
              /></app-btn>
              во&nbsp;время турнира, чтобы быть в&nbsp;быстрой доступности для
              судей.
            </p>
          </div>
        </div>

        <div
          key="info"
          class="page-section tournament__info"
          v-if="tournament.id"
        >
          <div class="page-section__content">
            <div class="tabs">
              <div class="tabs__list" ref="tabsList">
                <router-link
                  v-for="item in tabs"
                  class="tab"
                  active-class="tab_active"
                  :exact="item.exact"
                  :to="getLink(item.route)"
                  :key="`tab-${item.route}`"
                >
                  <div class="tab__wrap">{{ item.label }}</div>
                </router-link>
              </div>
              <div
                class="tabs__content"
                :class="contentsClasses"
                ref="tabsContent"
              >
                <div class="tabs__content_wrap">
                  <router-view />
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import tournamentsService from "@/services/tournaments";
import showAlert, {
  showSocialsAlert,
  requestAlert
} from "@/services/common/showAlert";
import showPrompt from "@/services/common/showPrompt";
import Countdown from "@/components/ui/timer/Countdown";
import AppStatus from "@/components/ui/status/AppStatus";

// import { TournamentStatusHelper } from "@/components/tournament/types";

window.showPrompt = showPrompt;

export default {
  components: { Countdown, AppStatus },
  data: () => ({
    tabsList: [
      {
        route: "tournament-info",
        label: "Инфо",
        types: [0, 1, 2],
        exact: true
      },
      {
        route: "tournament-bracket",
        label: "Сетка",
        types: [0, 1, 2],
        exact: true
      },
      {
        route: "tournament-matches",
        label: "Матчи",
        types: [0, 1, 2],
        exact: false
      },
      {
        route: "tournament-members",
        label: "Участники",
        types: [0, 1, 2],
        exact: true
      },
      {
        route: "tournament-rules",
        label: "Правила",
        types: [0, 1, 2],
        exact: true
      }
    ],

    isFullTabsLine: false,
    loading: false,
    participateLoading: false,
    checkInLoading: false
  }),

  computed: {
    contentsClasses() {
      return {
        "round-left-corner": this.$route.name !== this.tabs[0].route,
        "round-right-corner":
          !this.isFullTabsLine ||
          this.$route.name !== this.tabs[this.tabs.length - 1].route
      };
    },

    tabs() {
      return this.tabsList.filter(tab =>
        tab.types.includes(this.tournament.type)
      );
    },

    ...mapGetters(["routeParams"]),
    ...mapGetters("tournaments", [
      "tournament",
      "participation",
      "checkins",
      "tournamentStatuses"
    ]),
    ...mapGetters("auth", ["isAuthenticated", "isRegistred"]),

    isParticipant() {
      return this.participation.includes(this.tournament.id || 0);
    },

    isCheckinConfirmed() {
      return this.checkins.includes(this.tournament.id || 0);
    },

    isParticipationConfirmed() {
      return this.tournamentStatuses.CheckIn
        ? this.isCheckinConfirmed
        : this.isParticipant;
    },

    needShowParticipateBtn() {
      return (
        !this.isParticipant &&
        (this.tournamentStatuses.RegStarted ||
          this.tournamentStatuses.CheckIn) &&
        this.tournament.players_count < this.tournament.players_limit
      );
    },

    needShowCheckinBtn() {
      return (
        this.isParticipant &&
        this.tournamentStatuses.CheckIn &&
        !this.isCheckinConfirmed
      );
    },

    needShowUserStatus() {
      const { RegOver, GridReady, Live, CheckIn } = this.tournamentStatuses;
      const statuses = [RegOver, GridReady, Live];

      return (
        this.isParticipant &&
        (statuses.some(n => !!n) || (CheckIn && this.isCheckinConfirmed))
      );
    },

    isEmpty() {
      return (
        !this.needShowParticipateBtn &&
        !this.needShowCheckinBtn &&
        !this.needShowUserStatus
      );
    },

    canRegister() {
      return (
        [0, 1].includes(this.tournament.type) &&
        (this.needShowParticipateBtn ||
          this.needShowCheckinBtn ||
          this.isParticipationConfirmed)
      );
    }
  },

  watch: {
    $route: "checkTabsListWidth",
    tab: "checkTabsListWidth",
    tabs: "checkTabsListWidth",

    "routeParams.tournament_id": {
      handler: "fetchPageData",
      immediate: true
    }
  },

  sockets: {
    notification(message) {
      const isAllowed = ["matches_performed", "tournament_changed"].includes(
        message.type
      );
      const onCurTournament =
        this.routeParams.tournament_id === message.tournament_id;

      if (isAllowed && onCurTournament) {
        this.fetchPageData(true);
      }
    }
  },

  methods: {
    getLink(name, opts = {}) {
      return this.$router.resolve({ name, params: this.routeParams, ...opts })
        .href;
    },

    clacTabsWidth() {
      if (!this.$refs.tabsList) return 0;
      let list = this.$refs.tabsList.querySelectorAll(".tab");
      return Array(list.length)
        .fill(0)
        .map((n, i) => list[i].clientWidth)
        .reduce((res, val) => res + val);
    },

    checkTabsListWidth() {
      if (!this.$refs.tabsList && !this.$refs.tabsContent) return 0;
      let contentWidth = this.$refs.tabsContent.clientWidth - 6,
        tabsWidth = this.clacTabsWidth();
      this.isFullTabsLine = tabsWidth >= contentWidth;
    },

    async fetchPageData(force = false) {
      if (force || this.routeParams.tournament_id !== this.tournament.id) {
        if (this.loading) return;
        this.loading = true;

        let data = await tournamentsService.getInfo(
          this.routeParams.tournament_id
        );

        if (this.isAuthenticated && this.isRegistred) {
          await this.$store.dispatch("tournaments/checkTourParticipation");
        }

        this.$store.dispatch("tournaments/updateTournament", data);
        this.loading = false;
      }
    },

    async checkAndRequestPass() {
      if (this.tournament.type === 0) {
        const PASSWORDS = process.env.VUE_APP_PASSWORDS.split("|");

        return await showPrompt(
          "Введите пароль для регистрации",
          "password",
          value => {
            return value && PASSWORDS.includes(value.toLowerCase());
          }
        );
      }

      return true;
    },

    async participateTournament() {
      if (this.participateLoading) return;

      this.$app.metrics("click-tournament-participate");

      if (!this.isAuthenticated) {
        showAlert(
          "Участвовать в турнире могут только зарегистрированные пользователи.",
          0,
          true,
          "Авторизоваться",
          "center",
          () => {
            this.$store.dispatch("auth/login");
            this.$app.metrics("click-signin-inside-modal");
          }
        );
        return false;
      }

      if (!this.isRegistred) {
        this.$store.dispatch("auth/openProfile");
        return false;
      }

      this.participateLoading = true;

      try {
        let accessGranted = await this.checkAndRequestPass();
        if (!accessGranted) return false;

        let res = await tournamentsService.tournamentRegister(
          this.tournament.id
        );
        await this.$store.dispatch("tournaments/checkTourParticipation");
        await this.$store.dispatch("tournaments/updateTournament");

        if (res.message) showSocialsAlert(res.message);
      } catch (err) {
        console.log(err);
        requestAlert();
      } finally {
        this.participateLoading = false;
      }
    },

    async confirmTournamentRegistration() {
      if (this.checkInLoading) return;

      if (!this.isAuthenticated) {
        showAlert(
          "Участвовать в турнире могут только зарегистрированные пользователи.",
          0,
          true,
          "Авторизоваться",
          "center",
          () => this.$store.dispatch("auth/login")
        );
        return false;
      }

      this.checkInLoading = true;

      try {
        let res = await tournamentsService.checkInTournament(
          this.tournament.id
        );
        await this.$store.dispatch("tournaments/checkTourParticipation");
        await this.$store.dispatch("tournaments/updateTournament");

        if (res.message) showAlert(res.message, 2500);
      } catch (err) {
        console.log(err);
        requestAlert();
      } finally {
        this.checkInLoading = false;
      }
    }
  },

  mounted() {
    this.checkTabsListWidth();
    window.scrollTo(0, 0);
  }
};
</script>

<style lang="scss">
.info.registred {
  font-weight: normal;
}

.registred {
  color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  user-select: none;

  b {
    color: #fbc33e;
  }

  &_success {
    .registred__icon {
      color: #5bb34f;
    }
  }

  &__text {
    flex: 1 1 auto;
    font-size: 11px;
    line-height: 15px;
    max-width: 130px;
  }

  &__icon {
    margin-right: 8px;
    flex: 0 1 auto;
  }
}

.tab {
  display: inline-flex;
  align-items: center;
  text-align: center;

  letter-spacing: 0.02em;
  text-transform: uppercase;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #3b579f;
  cursor: pointer;
  padding: 10px 0;
  transition: $primary-transition;
  position: relative;
  z-index: 1;

  &__wrap {
    position: relative;
    z-index: 3;
    padding: 0 16px;
    width: 100%;
  }

  &:after {
    position: absolute;
    z-index: 2;
    content: "";
    display: block;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: gradient(#1e2135, #304d96, to bottom, 0.65, 0.65);
    background-size: 100% 100vh;
    opacity: 0;
    transition: $primary-transition;

    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
  }

  &_active {
    color: #fff;

    &:after {
      opacity: 1;
    }
  }

  &:not(:first-child) {
    &:before {
      content: "";
      width: 1px;
      height: 14px;
      display: inline-block;
      transition: $primary-transition;
    }
  }

  &:not(.tab_active) {
    .tab:not(:first-child):not(.tab_active) + &,
    & + .tab:not(.tab_active) {
      &:before {
        background: #3b579f;
      }
    }
  }

  @include breakpoint("xs-only") {
    flex: 0 1 auto;
    border-radius: 100px;
    text-transform: none;
    font-size: 16px;

    margin: 4px 0;
    padding: 6px 16px;

    &_active {
      background: gradient(#1e2135, #304d96, to bottom, 0.65, 0.65);
    }

    &:after,
    &:before,
    &:not(:first-child):before {
      display: none;
    }

    &__wrap {
      padding: 0px;
    }
  }
}

.tabs {
  &__list {
    display: flex;

    @include breakpoint("xs-only") {
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      padding: 4px 0;
    }
  }

  &__content {
    background: gradient(#1e2135, #304d96, to bottom, 0.65, 0.65);
    transition: $primary-transition;
    padding: 30px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    min-height: 400px;

    &.round-left-corner {
      border-top-left-radius: 6px;
    }
    &.round-right-corner {
      border-top-right-radius: 6px;
    }

    h2,
    p {
      font-size: 14px;
      line-height: 19px;

      &:not(:last-child) {
        margin-bottom: 20px;
      }
    }

    p {
      img {
        border-radius: 5px;
        transition: box-shadow 0.3s;
        will-change: box-shadow;
        cursor: pointer;

        box-shadow: 0px 0px 0px 1px rgba(#fbc33e, 0.4), 0px 3px 6px 0px #000a25;

        &:first-child {
          margin-left: 0 !important;
        }

        &:last-child {
          margin-right: 0 !important;
        }

        &:hover {
          box-shadow: 0px 0px 0px 1px rgba(#fbc33e, 0.8),
            0px 8px 10px 0px #000a25;
        }

        @include breakpoint("xs-only") {
          width: 40% !important;
          height: auto !important;

          &:nth-child(2n) {
            margin: 5px !important;
            margin-right: auto !important;
          }

          &:nth-child(2n + 1) {
            margin: 5px !important;
            margin-left: auto !important;
          }
        }
      }
    }

    .title {
      font-size: 24px;
      line-height: 33px;
      text-align: left;
    }

    h1,
    h2,
    h3,
    h4 {
      font-family: $second-font-family;
      font-weight: 900;
      line-height: 97.52%;
      letter-spacing: 0.02em;
      color: #fbc33e;
    }

    h1 {
      font-size: 2rem;
    }
    h2 {
      font-size: 1.7rem;
    }
    h3 {
      font-size: 1.4rem;
    }
    h4 {
      font-size: 1.2rem;
    }

    strong,
    b,
    a {
      font-weight: 800;
    }

    @include breakpoint("sm-and-down") {
      padding: 30px 10px;

      .tab__content {
        padding: 10px;
      }
    }

    @include breakpoint("xs-only") {
      border-radius: 6px;
      padding: 16px 4px;

      h1,
      h2,
      h3,
      h4,
      p {
        padding: 0 6px;
      }
    }
  }
}

.heading {
  font-family: $second-font-family;
  font-weight: 900;
  font-size: 52px;
  line-height: 63px;
  letter-spacing: 0.02em;
  color: #fbc33e;

  @include breakpoint("xs-only") {
    font-size: 32px;
    line-height: 1.47em;
  }
}

.subheading {
  font-family: $second-font-family;
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.02em;
  color: #fff;
}

.tournament {
  margin: 0 auto;

  > * {
    margin: 50px auto;
  }

  &__status {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 108.95%;
    font-weight: 800;
    border-radius: 6px;

    &.live {
      font-size: 20px;
      line-height: 100%;
      background: rgba(#5bb34f, 0.25);

      .status_offline span {
        color: #fff;
      }
    }

    &.ended {
      font-size: 20px;
      line-height: 100%;
      background: rgba(#e72f31, 0.3);
    }
  }

  &__notice {
    text-align: center;
    p {
      font-size: 14px;
      line-height: 19px;
    }

    .title {
      font-size: 18px;
      line-height: 26px;
      margin-bottom: 12px;
    }
  }

  &__format {
    &_wrap {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: center;

      .field {
        flex: 0 1 auto;
        // display: flex;
        // align-items: center;

        display: flex;
        align-items: flex-start;
        flex-direction: column;
        flex-wrap: wrap;
        order: 1;

        > * {
          flex: 1 1 auto;
        }

        .label {
          padding-right: 15px;
          flex: 0 1 auto;
          height: 100%;
          margin-bottom: 0;

          margin-bottom: 8px;
        }

        .info {
          width: 100%;
        }

        &.field_address {
          flex: 1 1 auto;
        }

        &.field_btn {
          flex: 0 1 auto;
          margin-top: 24px;

          .btn {
            display: flex;
            width: 100%;
          }
        }

        &.field_countdown {
          > * {
            flex: 1 0 100%;
          }
        }

        &.field_date {
          flex: 1 1 auto;
        }

        &.field_format {
          flex: 1 0 100%;
          > * {
            flex: 1 0 100%;
          }
        }
      }

      @include breakpoint("md-only") {
        .field {
          &.field_format {
            flex: 1 1 auto;
          }

          &.field_btn {
            order: 3;
          }
        }
      }

      @include breakpoint("sm-and-down") {
        .field {
          margin: 0;
          padding: 8px;
          flex: 1 1 auto;

          &.field_countdown,
          &.field_btn {
            order: 2;
            flex: 1 1 auto;
          }

          .label {
            margin-bottom: 8px;
          }

          &_btn {
            max-width: 100%;
          }
        }
      }

      @include breakpoint("xs-only") {
        .field {
          margin: 0;
          flex: 1 1 100%;
          max-width: 100%;

          &.field_date {
            flex: 1 1 50%;
            .info {
              justify-content: center;
            }
          }

          &.field_countdown {
            flex: 1 1 100%;

            .countdown {
              display: flex;
              flex: 1 1 100%;
              width: 100%;

              .day,
              .hour,
              .min,
              .sec {
                flex: 1 1 auto;
              }
            }
          }

          &.field_btn {
            margin-top: 0;
          }

          .registred {
            &__text {
              max-width: 100%;
              font-size: 14px;
            }
          }
        }
      }
    }
  }

  &__lables {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    label {
      display: flex;
      align-items: center;
      margin-right: 16px;
      height: 14px;

      + label {
        padding-left: 16px;
        border-left: 1px solid rgba(#fff, 0.5);
      }

      span {
        vertical-align: middle;
      }
      svg {
        margin-right: 8px;
      }
    }
  }

  &__member {
    background: rgba(#000a25, 0.6);
    padding: 10px 16px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-flow: row;
    transition: 0.3s;

    &.btn .btn__content {
      justify-content: flex-start;
      text-align: left;
    }

    .tournament__members_list:not(.tournament__members_list-empty) & {
      cursor: pointer;

      &:hover {
        box-shadow: 0px 0px 20px rgba(60, 171, 221, 0.75);
      }

      &:active {
        opacity: 0.5;
      }
    }

    .tournament__members_list-empty & {
      justify-content: center;
    }

    &__info {
      overflow: hidden;
    }

    &__ava {
      min-width: 40px;
      max-width: 40px;
      height: 40px;
      border: 2px solid;
      display: flex;
      align-items: center;
      justify-content: center;

      img,
      svg {
        display: block;
        width: 100%;
      }

      &:first-child {
        margin-right: 16px;
      }

      &:last-child {
        margin-left: 16px;
      }

      &_blue {
        background: #0d5577;
        border-color: #1480b2;
        color: rgba(#1480b2, 0.8);
      }

      &_red {
        background: #811314;
        border-color: #e72f31;
        color: rgba(#e72f31, 0.8);
      }
    }

    &_name {
      font-weight: 800;
      font-size: 14px;
      line-height: 15px;
      color: #fff;
      text-transform: uppercase;
      max-width: 140px;
    }
    &_country {
      font-size: 10px;
      line-height: 108.95%;
      color: rgba(#fff, 0.5);
      text-transform: none;
      font-weight: normal;
    }
  }

  &__game {
    padding: 10px 30px;
    background: rgba(#000a25, 0.6);
    border-radius: 6px;
    transition: 0.3s;

    .tournament__games_list:not(.tournament__games_list-empty) & {
      &:not(.empty) {
        cursor: pointer;

        &:hover {
          box-shadow: 0px 0px 20px rgba(60, 171, 221, 0.75);
        }

        &:active {
          opacity: 0.5;
        }
      }

      &.empty {
        opacity: 0.5;
        cursor: default;
      }
    }

    .tournament__member {
      padding: 0;
      background: transparent;
      display: flex;
      align-items: center;
      overflow: hidden;
      justify-content: flex-end;
      border-radius: 0;
      max-width: 200px;
      width: 100%;

      &:last-child {
        justify-content: flex-start;
      }
    }

    &_type,
    &_status {
      display: flex;
      align-items: center;

      padding: 0;
      font-size: 10px;
      line-height: 108.95%;
      color: rgba(#fff, 0.5);
      max-width: 120px;
    }

    &_type {
      justify-content: flex-start;
    }

    &_status {
      justify-content: flex-end;
      font-weight: 800;
    }
  }

  &__teams {
    display: flex;
    align-items: center;
    overflow: hidden;
    justify-content: center;
    padding: 0;

    &__result {
      display: flex;
      align-items: center;
      justify-content: center;

      font-weight: 800;
      font-size: 14px;
      line-height: 20px;
      color: #fbc33e;
      max-width: 70px;
      min-width: 70px;
      text-align: center;

      .result-delimeter {
        padding: 0 8px;
      }
    }
  }

  &__filter {
    &_categories {
      @include breakpoint("xs-only") {
        display: flex;
        align-items: center;

        .btn {
          display: flex;
          flex: 1 1 auto;
        }
      }

      .btn {
        padding: 8px 30px;
        margin-right: 16px;

        &:last-child {
          margin-right: 0;
        }

        &__content {
          text-transform: none !important;
          font-weight: normal;
          font-size: 12px;
          line-height: 13px;
        }
      }
    }

    &_search {
      .text-field {
        padding: 8px 30px;

        input {
          font-size: 12px;
          line-height: 14px;
        }
      }
    }
  }

  @include breakpoint("xs-only") {
    &__game {
      flex-wrap: wrap;
    }

    &__game_type,
    &__game_status {
      order: 1;
      max-width: 100% !important;
    }

    &__teams {
      order: 2;
      flex: 1 0 100% !important;
      justify-content: flex-start;
      flex-wrap: wrap;

      padding: 0 !important;
      position: relative;
    }

    &__teams__result {
      order: 2;
      flex: 1 1 20%;
      max-width: 20%;
      align-self: flex-start;
      justify-content: flex-end;
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
      height: 100%;

      &_wrap {
        display: flex;
        flex-direction: column;
        height: 100%;
        min-width: 18px;
      }

      .result-delimeter {
        display: none;
      }

      .result-red,
      .result-blue,
      .result-empty {
        height: 50%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .result-empty {
        height: 100%;
      }
    }

    &__member {
      &_name {
        max-width: 300px;
      }

      .tournament__games & {
        order: 1;
        justify-content: flex-start !important;
        padding: 8px 0 !important;
        flex: 1 1 80%;
        max-width: 80%;

        &__info {
          order: 2;
          text-align: left !important;
        }
        &__ava {
          order: 1;

          &:last-child {
            margin-left: 0;
            margin-right: 16px;
          }
        }
      }
    }
  }
}

.floated-box {
  &.right {
    padding-left: 30px;
  }

  &.left {
    padding-right: 30px;
  }
}

@include breakpoint("xs-only") {
  .floated-box.right {
    float: none;
    padding: 0;
  }
}

@include firefox() {
  .tabs__content h1,
  .tabs__content h2,
  .tabs__content h3,
  .tabs__content h4,
  .heading {
    font-family: $second-font-family !important;
    font-weight: 900 !important;
  }

  .subheading {
    font-family: $second-font-family !important;
    font-weight: 300 !important;
  }
}
</style>
